import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { lighterBlue } from '~theme';
import { logOut } from '~actions/rootActions';
import { setShow as setModalShow } from '~features/modals/ducks';

import { config } from '../../configuration';

import logoutIcon from '~images/logout.svg';

import ToggleButton from '~ui-kit/ToggleButton';
import { Gap, Button } from '~ui-kit';

import Drawer from './index';

import { toggleDrawer } from './ducks';
import ProfileUnitChange from './components/ProfileUnitChange';
import FollowedUnit from './components/FollowedUnit';
import AddFollowedUnit from './components/AddFollowedUnit';
import Header from './components/Header';
import PhoneNumber from './components/PhoneNumber';

import {
  getUser,
  toggleEmailNotification,
  getUserOrganization,
  selectUserOrganization,
  addFollowedOrganization,
  removeFollowedOrganization,
} from '../user/ducks';

const ProfileDrawer = ({
  user,
  userOrganizations,
  setModalShow,
  toggleDrawer,
  selectUserOrganization,
  addFollowedOrganization,
  removeFollowedOrganization,
  toggleEmailNotification,
  logOut,
}) => {
  const username = user ? user.name : 'Ladataan käyttäjän tietoja...';

  return (
    <Drawer name="profile">
      <StyledHeader title={username} />

      {user && <PhoneNumber user={user} />}

      <Gap height="32px" />

      <Logout>
        <LogoutButton onClick={logOut}>
          <LogoutIcon src={logoutIcon} />
          <span>Kirjaudu ulos</span>
        </LogoutButton>
      </Logout>

      <SectionLabel>Yksikköni Paketissa</SectionLabel>
      <ProfileUnitChange
        user={user}
        userOrganizations={userOrganizations}
        activeUnit={user.ordererOrganization}
        onUnitSelect={selectUserOrganization}
      />

      <Gap height="32px" />

      <SectionLabel>Seurannassa olevat yksiköt</SectionLabel>

      {user && user.ordererOrganization && userOrganizations && (
        <UnitContainer>
          {user.followedOrganizations &&
            user.followedOrganizations.map(unit => (
              <FollowedUnit
                key={unit.id}
                unit={unit}
                removeFollowedOrganization={removeFollowedOrganization}
              />
            ))}

          <AddFollowedUnit
            userOrganizations={userOrganizations}
            user={user}
            addFollowedOrganization={addFollowedOrganization}
          />
        </UnitContainer>
      )}

      <Permissions
        onClick={() => {
          setModalShow('REQUEST_PERMISSIONS');
          toggleDrawer('profile');
        }}
      >
        <CantFindText>Yksikkö ei löydy listalta</CantFindText>
        <ChevronRight icon={faChevronRight} aria-hidden="true" />
      </Permissions>

      <Gap height="36px" />

      <ToggleButton
        label="Sähköposti-ilmoitukset"
        isToggled={user && user.emailNotifications}
        onToggle={toggleEmailNotification}
      />

      <ResponsiveBorderedGap height="36px" />
      <ResponsiveGap height="36px" />

      <AppVersion>
        <span>Versio: {config.appVersion}</span>
        <span>Palvelin: {config.hostname}</span>
      </AppVersion>
    </Drawer>
  );
};

const StyledHeader = styled(Header)`
  padding-bottom: 8px;
`;

const SectionLabel = styled.div`
  display: flex;
  font-size: 14px;
  margin: 0px 0px 16px 0px;
  color: #fff;

  & > i {
    margin-right: 12px;
    font-size: 16px;
  }
`;

const LogoutButton = styled(Button)`
  background-color: ${lighterBlue};
  width: 220px;
  padding: 12px 60px;
`;

const Logout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  border-bottom: 1px solid white;
  padding-bottom: 40px;
  margin-bottom: 40px;
`;

const ResponsiveGap = styled(Gap)`
  height: 48px;

  @media (max-width: 768px) {
    height: 24px;
  }
`;

const ResponsiveBorderedGap = styled(ResponsiveGap)`
  border-bottom: 1px solid white;
`;

const LogoutIcon = styled.img`
  width: 18px;
  height: auto;
  margin-right: 16px;
`;

const UnitContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 18px;
  & > div:not(:first-child) {
    margin-top: 14px;
  }
`;

const Permissions = styled.div`
  margin-top: 60px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid white;
  padding-bottom: 36px;
`;

const CantFindText = styled.a`
  text-decoration: underline;
  color: white;
`;

const ChevronRight = styled(FontAwesomeIcon)`
  margin-left: 16px;
  margin-top: 1px;
`;

const AppVersion = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 36px;
  color: #fff;
  gap: 8px;
`;

// Select values from Redux store and pass them as props to component
const mapStateToProps = state => ({
  user: getUser(state),
  userOrganizations: getUserOrganization(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleDrawer,
      logOut,
      toggleEmailNotification,
      selectUserOrganization,
      addFollowedOrganization,
      removeFollowedOrganization,
      setModalShow,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDrawer);
